"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchedAircraftHandler = exports.removePilotAircraftHandler = exports.editAircraftHandler = exports.addPilotAircraftHandler = exports.getPilotAircraftHandler = void 0;
const store_1 = require("../store/redux/store");
const aircraft_1 = require("../http/aircraft");
const account_1 = require("../store/redux/account");
const lodash_1 = require("lodash");
const searchHelpers_1 = require("../services/searchHelpers");
const getPilotAircraftHandler = () => {
    (0, aircraft_1.getPilotAircraft)().then(response => {
        store_1.store.dispatch((0, account_1.setPilotProfileAction)({ aircraft: response }));
    }).catch(error => {
        console.log(error);
    });
};
exports.getPilotAircraftHandler = getPilotAircraftHandler;
const addPilotAircraftHandler = (id, data, edited) => {
    if ((0, lodash_1.isNumber)(id)) {
        if (edited) {
            (0, aircraft_1.editAircraft)(id, { ...(0, lodash_1.omit)(data, 'id', 'reg_number') }).then(_ => {
                (0, aircraft_1.addPilotAircraft)(id).then(_ => {
                    (0, exports.getPilotAircraftHandler)();
                }).catch(error => console.log(error));
            }).catch(error => {
                console.log(error);
            });
        }
        else {
            (0, aircraft_1.addPilotAircraft)(id).then(_ => {
                (0, exports.getPilotAircraftHandler)();
            }).catch(error => console.log(error));
        }
    }
    else {
        (0, aircraft_1.createAircraft)({ ...(0, lodash_1.omit)(data, 'id') }).then(id => {
            (0, aircraft_1.addPilotAircraft)(id).then(_ => {
                (0, exports.getPilotAircraftHandler)();
            }).catch(error => console.log(error));
        }).catch(error => {
            console.log(error);
        });
    }
};
exports.addPilotAircraftHandler = addPilotAircraftHandler;
const editAircraftHandler = (id, data) => {
    (0, aircraft_1.editAircraft)(id, { ...(0, lodash_1.omit)(data, 'id', 'reg_number') }).then(_ => {
        (0, exports.getPilotAircraftHandler)();
    }).catch(error => {
        console.log(error);
    });
};
exports.editAircraftHandler = editAircraftHandler;
const removePilotAircraftHandler = (id) => {
    (0, aircraft_1.removePilotAircraft)(id).then(response => {
        store_1.store.dispatch((0, account_1.setPilotProfileAction)(response));
        (0, exports.getPilotAircraftHandler)();
    }).catch(error => {
        console.log(error);
    });
};
exports.removePilotAircraftHandler = removePilotAircraftHandler;
const getSearchedAircraftHandler = (inputValue, callback) => {
    if (inputValue.length >= 2) {
        (0, aircraft_1.getSearchedAircraft)(inputValue).then((response) => {
            const options = response.map(aircraft => (0, searchHelpers_1.mapAircraftToOption)(aircraft));
            callback(options);
        });
    }
    else
        callback([]);
};
exports.getSearchedAircraftHandler = getSearchedAircraftHandler;
